export function getFrameUrl(mediaSubFile, frame = 1) {
    return mediaSubFile.externalLink.replace('vindex.json', `f${frame}.jpg`);
}
